import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AddNewDataModel} from '../model/add-new-data-model';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AddNewService} from '../service/add-new.service';

@Component({
  selector: 'app-add-new',
  templateUrl: './add-new.component.html',
  styleUrls: ['./add-new.component.css'],
})
export class AddNewComponent implements OnInit {
  public formGroup: FormGroup;
  public data: AddNewDataModel;
  public submitted = false;

  @Output('onSave')
  public saveCallback: EventEmitter<AddNewDataModel> = new EventEmitter<AddNewDataModel>();

  @Output('onCancel')
  public cancelCallback: EventEmitter<void> = new EventEmitter<void>();

  constructor(public service: AddNewService,
              public router: Router,
              public toasterService: ToastrService,
              private activeRoute: ActivatedRoute,
              private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.setData(this.getNewModal());
    this.setValidation();
  }

  public getActiveRoute(): ActivatedRoute {
    return this.activeRoute;
  }

  public getFormGroup(): FormGroup {
    return this.formGroup;
  }

  public getNewModal(): AddNewDataModel {
    return new AddNewDataModel();
  }

  getData(): AddNewDataModel {
    return this.data;
  }

  setData(data: AddNewDataModel) {
    this.data = data;
  }

  setValidation() {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['']
    });
  }

  get f() { return this.formGroup.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.getFormGroup().invalid) {
      return;
    }
    this.saveCallback.emit(this.data);
  }

  onCancel() {
    this.cancelCallback.emit();
  }
}
